<template>
    <div>
        <v-card>
            <s-toolbar @save="save()" :save="isUserCreated" close @close="$emit('close')" :label="advanceProducer.AdpID > 0
                ? 'Actualizar Adelanto'
                : 'Registrar Adelanto'
                ">
                <v-tooltip bottom="" v-if="approvedOption">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" small @click="approved()">
                            <v-icon color="green" style="font-size: 16px">
                                far fa-thumbs-up</v-icon></v-btn>
                    </template>
                    <span>Aprobar</span>
                </v-tooltip>

                <v-tooltip bottom="" v-if="approvedOption">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" small @click="dialogDissaproved = true">
                            <v-icon color="red" style="font-size: 16px">
                                far fa-thumbs-down</v-icon></v-btn>
                    </template>
                    <span>Desaprobar</span></v-tooltip>
            </s-toolbar>

            <v-divider></v-divider>
            <v-col style="padding-top: 4px; padding-bottom: 4px">
                <v-row>
                    <!-- ===== DATOS DEL ADELANTO (Ancho Completo - Stacked) ===== -->
                    <v-col cols="12">
                        <v-card class="elevation-2"
                            style="border-radius: 12px;overflow: hidden;border: 1px solid rgba(224, 224, 224, 0.5);box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03) !important;">
                            <v-card-title class="py-3 px-4 d-flex align-center"
                                style="min-height: 48px;background: #ffffff;border-top: 4px solid #1976d2;">
                                <div class="d-flex align-center justify-center mr-3"
                                    style="background-color: rgba(25, 118, 210, 0.08);border-radius: 50%;width: 32px;height: 32px;">
                                    <v-icon size="18" color="primary">mdi-information-outline</v-icon>
                                </div>
                                <span style="color: #1e293b;font-size: 13px;font-weight: 700;letter-spacing: 0.5px;">
                                    DATOS DEL ADELANTO
                                </span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pa-3 pt-3" style="background-color: #fafdff">
                                <v-row dense>
                                    <!-- Columna Izquierda (70% del ancho) -->
                                    <v-col cols="12" md="7" class="pr-md-4">
                                        <!-- Fila 1: Fecha, Campaña, Moneda -->
                                        <v-row dense align="baseline">
                                            <v-col cols="12" sm="3">
                                                <s-date ref="APDate" label="Fecha"
                                                    v-model="advanceProducer.ApplicationDate" :disabled="viewMode" />
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <s-select-campaign-area label="Campaña" v-model="advanceProducer.CmaID"
                                                    typeArea="1"
                                                    :disabled="viewMode || isEditable"></s-select-campaign-area>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <s-select-definition :disabled="viewMode" :def="1129" label="Moneda"
                                                    :value="advanceProducer.TypeCurrency"
                                                    @input="handleCurrencyChange($event)" returnObject />
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                                <s-text label="Tipo de Cambio" :value="displayExchangeRate" readonly
                                                    decimal />
                                            </v-col>
                                        </v-row>

                                        <!-- Fila 2: Productor, Supervisor de Fundo -->
                                        <v-row dense align="baseline" class="mt-2">
                                            <v-col cols="12" sm="6">
                                                <s-select-producer v-model="advanceProducer.PrdID" label="Productor"
                                                    :text="advanceProducer.ProducerName"
                                                    :disabled="viewMode || isEditable"
                                                    @changeProd="handleProducerChange"></s-select-producer>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <s-select-supervice-producer label="Supervisor de Fundo"
                                                    v-model="advanceProducer.NtpSuperviceID"
                                                    :text="advanceProducer.SuperviceName"
                                                    :produceID="objProducer ? objProducer.PrdID : null"
                                                    :disabled="viewMode"></s-select-supervice-producer>
                                            </v-col>
                                        </v-row>

                                        <!-- Fila 3: Tipo de Adelanto y Opción de IGV -->
                                        <v-row dense align="center" class="mt-2">
                                            <v-col cols="12" :sm="advanceProducer.TypeAdvance === 1 ? 7 : 12">
                                                <div style="padding-top: -2px; margin-top: -2px">
                                                    <v-label><b>Tipo de Adelanto</b></v-label>
                                                    <v-btn-toggle v-model="advanceProducer.TypeAdvance" mandatory
                                                        class="control" rounded-pill dense aria-label="Modo">
                                                        <v-btn v-for="opt in options" :key="opt.value"
                                                            :value="opt.value" class="seg-btn" :aria-pressed="String(
                                                                advanceProducer.TypeAdvance === opt.value,
                                                            )
                                                                " style="height: fit-content !important"
                                                            :disabled="viewMode">
                                                            <v-icon color="primary" v-if="opt.icon" left>{{
                                                                opt.icon
                                                                }}</v-icon>
                                                            <span class="inline-block text-caption">{{
                                                                opt.label
                                                                }}</span>
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>
                                            </v-col>

                                            <!-- Opción Incluye IGV (Solo para Insumos) -->
                                            <v-col cols="12" sm="5" v-if="advanceProducer.TypeAdvance === 1" class="d-flex align-center pt-2 pt-sm-4">
                                                <v-switch v-model="advanceProducer.IncludesTax" color="success"
                                                    hide-details dense class="ma-0 pa-0" :disabled="viewMode">
                                                    <template v-slot:label>
                                                        <span class="text-caption font-weight-bold grey--text text--darken-3">
                                                            <v-icon small color="success" class="mr-1">mdi-percent-outline</v-icon>
                                                            Incluye IGV (18%)
                                                        </span>
                                                    </template>
                                                </v-switch>
                                            </v-col>
                                        </v-row>

                                        <!-- Fila 4: Justificación, Observación -->
                                        <v-row justify="start" class="mt-2">
                                            <v-col cols="12" sm="6">
                                                <s-textarea label="Justificación"
                                                    v-model="advanceProducer.AdpJustification" ref="APJustification"
                                                    :readonly="viewMode == true" style="padding: 0px" :rows="2"
                                                    dense></s-textarea>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="mt-2 mt-sm-0">
                                                <s-textarea label="Observación" v-model="advanceProducer.Observation"
                                                    ref="APObservation" :readonly="viewMode == true"
                                                    style="padding: 0px" :rows="2" dense></s-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <!-- Columna Derecha (Dividida en Deudas y Jabas) -->
                                    <v-col cols="12" md="5" class="mt-4 mt-md-0 pl-md-0 pl-md-2">
                                        <v-row class="fill-height">
                                            <!-- Subcolumna 1: Deudas del Productor -->
                                            <v-col cols="12" sm="6" class="d-flex flex-column">
                                                <v-card outlined class="flex-grow-1 elevation-0"
                                                    style="border-radius: 8px;border: 1px solid #e0e0e0;min-height: 200px;">
                                                    <v-card-title
                                                        class="subtitle-2 font-weight-bold py-2 px-3 grey lighten-5 d-flex align-center">
                                                        <v-icon small color="error" class="mr-2">
                                                            mdi-alert-circle-outline
                                                        </v-icon>
                                                        Deudas del Productor
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-card-text class="pa-0 overflow-y-auto"
                                                        style="max-height: 220px; min-height: 160px">
                                                        <div v-if="producerDebts && producerDebts.length > 0">
                                                            <v-simple-table dense class="elevation-0 pa-0">
                                                                <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th
                                                                                class="text-center text-caption font-weight-bold pa-1">
                                                                                Tipo
                                                                            </th>
                                                                            <th
                                                                                class="text-center text-caption font-weight-bold pa-1">
                                                                                Total
                                                                            </th>
                                                                            <th
                                                                                class="text-center text-caption font-weight-bold pa-1">
                                                                                Saldo
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(debt, idx) in producerDebts"
                                                                            :key="idx">
                                                                            <td class="pa-1 text-truncate"
                                                                                style="max-width: 90px;font-size: 10px !important;">
                                                                                {{ debt.TypeAdvanceName }}
                                                                            </td>
                                                                            <td class="text-right pa-1 font-weight-medium"
                                                                                style="font-size: 10px !important;">
                                                                                {{ debt.TypeCurrencyName }}
                                                                                {{ formatNumber(debt.TotalAmount) }}
                                                                            </td>
                                                                            <td class="text-right pa-1 font-weight-bold red--text"
                                                                                style="font-size: 10px !important;">
                                                                                {{ debt.TypeCurrencyName }}
                                                                                {{ formatNumber(debt.TotalBalance) }}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </template>
                                                            </v-simple-table>
                                                        </div>
                                                        <div v-else
                                                            class="d-flex flex-column align-center justify-center text-center fill-height py-4">
                                                            <v-icon color="grey lighten-1" size="28"
                                                                class="mb-1">mdi-check-circle-outline</v-icon>
                                                            <div class="grey--text text--darken-1 text-caption">
                                                                Sin deudas registradas
                                                            </div>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>

                                            <!-- Subcolumna 2: Campaña Seleccionable (anteriormente Jabas por Campaña) -->
                                            <v-col cols="12" sm="6" class="d-flex flex-column">
                                                <v-card outlined class="flex-grow-1 elevation-0"
                                                    style="border-radius: 8px;border: 1px solid #e0e0e0;min-height: 200px;">
                                                    <v-card-title
                                                        class="subtitle-2 font-weight-bold py-2 px-3 grey lighten-5 d-flex align-center">
                                                        <v-icon small color="primary" class="mr-2">
                                                            mdi-calendar-multiselect
                                                        </v-icon>
                                                        Campaña de Exportación
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-card-text class="pa-0 px-1 overflow-y-auto"
                                                        style="max-height: 220px; min-height: 160px">
                                                        <div v-if="campaignAreas && campaignAreas.length > 0">
                                                            <v-list dense class="pa-0">
                                                                <v-list-item v-for="camp in campaignAreas"
                                                                    :key="camp.CmaID" class="px-0"
                                                                    style="min-height: 36px">
                                                                    <v-list-item-action class="mr-3 my-0">
                                                                        <v-checkbox v-model="selectedSubCampaign"
                                                                            :value="camp.CmaID" color="primary"
                                                                            hide-details></v-checkbox>
                                                                    </v-list-item-action>
                                                                    <v-list-item-content class="py-1">
                                                                        <v-list-item-title
                                                                            class="text-caption font-weight-medium text-wrap">
                                                                            {{ camp.CmaName }}
                                                                        </v-list-item-title>
                                                                        <v-list-item-subtitle
                                                                            class="text-caption grey--text text-truncate"
                                                                            v-if="
                                                                                camp.TypeAreaName ||
                                                                                camp.TypeCultiveName
                                                                            ">
                                                                            {{ camp.TypeAreaName }}
                                                                            <span v-if="
                                                                                camp.TypeAreaName &&
                                                                                camp.TypeCultiveName
                                                                            ">|</span>
                                                                            {{ camp.TypeCultiveName }}
                                                                        </v-list-item-subtitle>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list>
                                                        </div>
                                                        <div v-else
                                                            class="d-flex flex-column align-center justify-center text-center fill-height py-4">
                                                            <v-icon color="grey lighten-1" size="28"
                                                                class="mb-1">mdi-calendar-blank-outline</v-icon>
                                                            <div class="grey--text text--darken-1 text-caption">
                                                                Seleccione una campaña a la izquierda
                                                            </div>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <!-- ===== SECCIÓN DETALLE ITEMS ===== -->
                <v-card class="mt-3 elevation-2" style="
            border-radius: 12px;
            overflow: hidden;
            border: 1px solid rgba(224, 224, 224, 0.5);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03) !important;
          ">
                    <v-card-title class="py-3 px-4 d-flex align-center" style="
              min-height: 48px;
              background: #ffffff;
              border-top: 4px solid #f57c00;
            ">
                        <div class="d-flex align-center justify-center mr-3" style="
                background-color: rgba(245, 124, 0, 0.08);
                border-radius: 50%;
                width: 32px;
                height: 32px;
              ">
                            <v-icon size="18" color="orange darken-3">mdi-format-list-bulleted</v-icon>
                        </div>
                        <span style="
                color: #1e293b;
                font-size: 13px;
                font-weight: 700;
                letter-spacing: 0.5px;
              ">
                            DETALLE DEL ADELANTO
                        </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-3 pt-3" style="background-color: #fafdff">
                        <v-row>
                            <v-col md="4" sm="12" col="12">
                                <s-toolbar color="" label="" :add="viewMode == false" :edit="isItemEditable()"
                                    :remove="isItemEditable()" @add="add()" @edit="edit()" @removed="removeItem()"
                                    @save="add()" @clear="clearFormDetail()" clear />
                                <v-divider></v-divider>
                                <v-card rounded="" class="elevation-0">
                                    <v-row>
                                        <v-col v-if="advanceProducer.TypeAdvance === 1" class="s-col-form" lg="12">
                                            <s-article-search v-model="article" :disabled="viewMode" />
                                        </v-col>
                                        <v-col v-else-if="advanceProducer.TypeAdvance === 2" class="s-col-form" lg="12"
                                            cols="12">
                                            <s-text label="Descripción | Motivo" text ref="Description"
                                                v-model="item.Description" :readonly="viewMode" />
                                        </v-col>

                                        <v-col class="s-col-form" lg="6" cols="12">
                                            <s-text :label="advanceProducer.TypeAdvance === 1
                                                ? 'Cantidad'
                                                : 'Monto'
                                                " decimal ref="LsQuantity" v-model="item.Quantity"
                                                :readonly="viewMode" />
                                        </v-col>

                                        <v-col class="s-col-form" lg="6" cols="12"
                                            v-if="advanceProducer.TypeAdvance === 1">
                                            <s-text label="Precio Unitario" decimal ref="LsUnitPrice"
                                                v-model="item.UnitPrice" :readonly="viewMode" />
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>

                            <v-col md="8" sm="12" col="12">
                                <s-toolbar label="Detalle"></s-toolbar>
                                <v-card rounded="" class="elevation-0">
                                    <v-col style="padding: 0px">
                                        <v-data-table mobile-breakpoint="0" item-key="LsNumLine" dense
                                            :items="items.filter((i) => i.SecStatus !== 0)" v-model="selected" :height="!isEditable
                                                ? '120'
                                                : $vuetify.breakpoint.xs
                                                    ? 'auto'
                                                    : '120'
                                                " :headers="headersDetail" class="elevation-0" :items-per-page="-1"
                                            @click:row="rowClick" :sort-by="['LsNumLine']" :sort-desc="[true]">
                                            <template v-slot:item.TypeAdvance="{ item }">
                                                <div class="text-start pa-0">
                                                    {{
                                                        options.find((x) => x.value === item.TypeAdvance)
                                                            ?.label ?? "---"
                                                    }}
                                                </div>
                                            </template>
                                            <template v-slot:item.Description="{ item }">
                                                <div class="text-start text-uppercase pa-0">
                                                    {{ item.Description }}
                                                </div>
                                            </template>
                                            <template v-slot:item.Quantity="{ item }">
                                                <div class="text-center pa-0">
                                                    {{ item.TypeAdvance == 1 ? item.Quantity : 1 }}
                                                </div>
                                            </template>
                                            <template v-slot:item.UnitPrice="{ item }">
                                                <div class="text-end pa-0">
                                                    {{ formatNumber(item.UnitPrice) }}
                                                </div>
                                            </template>
                                            <template v-slot:item.totalRow="{ item }">
                                                <div class="text-end pa-0 font-weight-bold blue--text text--darken-2">
                                                    {{
                                                        formatCurrency2Decimals(
                                                            item.TypeAdvance == 1
                                                                ? item.Quantity * item.UnitPrice
                                                                : item.UnitPrice,
                                                        )
                                                    }}
                                                </div>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!-- ===== METRICAS DE RESUMEN Y TOTAL (Premium Dashboard) ===== -->
                        <v-row class="mt-4 pt-2 align-stretch" justify="end">
                            <!-- Tarjeta Subtotal Neto (Visible solo si es Insumos con IGV) -->
                            <v-col v-if="advanceProducer.TypeAdvance === 1 && advanceProducer.IncludesTax" cols="12" sm="4" md="3" class="d-flex mb-2 mb-sm-0">
                                <v-card class="elevation-1 flex-grow-1" style="border-radius: 12px; border: 1px solid #e2e8f0; background: #ffffff;">
                                    <v-card-text class="pa-3 d-flex align-center justify-space-between">
                                        <div>
                                            <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase">Subtotal (Sin IGV)</div>
                                            <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mt-1">
                                                {{ currencySymbol }} {{ totalSuppliesNet.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                            </div>
                                        </div>
                                        <v-avatar color="grey lighten-4" size="32">
                                            <v-icon color="grey darken-2" size="16">mdi-calculator</v-icon>
                                        </v-avatar>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <!-- Tarjeta IGV (Visible solo si es Insumos con IGV) -->
                            <v-col v-if="advanceProducer.TypeAdvance === 1 && advanceProducer.IncludesTax" cols="12" sm="4" md="3" class="d-flex mb-2 mb-sm-0">
                                <v-card class="elevation-1 flex-grow-1" style="border-radius: 12px; border: 1px solid #c8e6c9; background: #f1f8e9;">
                                    <v-card-text class="pa-3 d-flex align-center justify-space-between">
                                        <div>
                                            <div class="text-caption font-weight-bold green--text text--darken-3 text-uppercase">IGV (18%)</div>
                                            <div class="text-subtitle-1 font-weight-bold green--text text--darken-3 mt-1">
                                                {{ currencySymbol }} {{ igvSuppliesAmount.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                            </div>
                                        </div>
                                        <v-avatar color="green lighten-4" size="32">
                                            <v-icon color="green darken-2" size="16">mdi-percent-outline</v-icon>
                                        </v-avatar>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <!-- Monto Total del Adelanto (Destacado) -->
                            <v-col cols="12" sm="6" :md="advanceProducer.TypeAdvance === 1 && advanceProducer.IncludesTax ? 4 : 4" class="d-flex">
                                <v-card class="elevation-2 flex-grow-1" style="
                    border-radius: 12px;
                    overflow: hidden;
                    background: linear-gradient(
                      135deg,
                      #1e3c72 0%,
                      #2a5298 100%
                    );
                    color: white;
                    box-shadow: 0 4px 15px rgba(30, 60, 114, 0.25) !important;
                  ">
                                    <v-card-text class="pa-3 d-flex align-center"
                                        style="justify-content: space-between; width: 100%">
                                        <div style="flex-grow: 1">
                                            <div style="
                          font-size: 10px;
                          font-weight: 600;
                          letter-spacing: 1px;
                          text-transform: uppercase;
                          color: rgba(255, 255, 255, 0.85);
                        ">
                                                {{ advanceProducer.TypeAdvance === 1 && advanceProducer.IncludesTax ? 'Total Adelanto (con IGV)' : 'Total Adelanto' }}
                                            </div>
                                            <div style="
                          font-size: 22px;
                          font-weight: 800;
                          margin-top: 2px;
                          letter-spacing: 0.5px;
                          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
                        ">
                                                {{ currencySymbol }}
                                                {{
                                                    totalAmount.toLocaleString("es-PE", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })
                                                }}
                                            </div>
                                        </div>
                                        <v-avatar color="rgba(255, 255, 255, 0.15)" size="36">
                                            <v-icon color="white" size="18">mdi-cash-check</v-icon>
                                        </v-avatar>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-row class="mt-3">
                    <!-- ===== SELECCIÓN DETALLE FUNDO (Ancho Completo - Stacked) ===== -->
                    <v-col cols="12">
                        <v-card class="elevation-2" style="
                border-radius: 12px;
                overflow: hidden;
                border: 1px solid rgba(224, 224, 224, 0.5);
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03) !important;
              ">
                            <v-card-title class="py-3 px-4 d-flex align-center" style="
                  min-height: 48px;
                  background: #ffffff;
                  border-top: 4px solid #2e7d32;
                ">
                                <div class="d-flex align-center justify-center mr-3" style="
                    background-color: rgba(46, 125, 50, 0.08);
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                  ">
                                    <v-icon size="18" color="green darken-3">mdi-sprout</v-icon>
                                </div>
                                <span style="
                    color: #1e293b;
                    font-size: 13px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                  ">
                                    SELECCIÓN DE FUNDOS
                                </span>
                                <v-spacer></v-spacer>
                                <v-btn v-if="selectedFundo.length > 0" color="green darken-3" dark small
                                    class="text-none font-weight-bold" style="border-radius: 8px"
                                    @click="dialogProductionValue = true">
                                    <v-icon left size="16">mdi-calculator</v-icon>
                                    Calcular Valor Producción
                                </v-btn>
                                <v-btn v-if="true" color="blue darken-3" dark small
                                    class="text-none font-weight-bold ml-2" style="border-radius: 8px"
                                    @click="openMarketPriceDialog()">
                                    <v-icon left size="16">mdi-trending-up</v-icon>
                                    Ver precio mercado
                                </v-btn>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pa-3 pt-3" style="background-color: #fafdff">
                                <v-card rounded="" class="elevation-0 mt-2">
                                    <v-col style="padding: 0px">
                                        <v-data-table mobile-breakpoint="0" item-key="FltID" dense show-select
                                            :items="fundos" v-model="selectedFundo" :headers="computedHeaders"
                                            class="elevation-1" :items-per-page="-1" height="250" :disabled="viewMode">
                                            <template v-slot:item.actionsMarketPrice="{ item }">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn icon v-on="on" small color="blue darken-3"
                                                            @click="openMarketPriceDialog(item)">
                                                            <v-icon small>mdi-trending-up</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver precio mercado lote</span>
                                                </v-tooltip>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-card>

        <!-- Modal: Calculadora de Valor Total de la Producción -->
        <v-dialog v-model="dialogProductionValue" max-width="1000px" persistent>
            <v-card style="border-radius: 12px; overflow: hidden">
                <v-card-title class="green darken-3 white--text pa-4 d-flex align-center">
                    <v-icon color="white" class="mr-3">mdi-calculator-variant</v-icon>
                    <span class="text-h6 font-weight-bold">Calcular Valor Total de la Producción</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogProductionValue = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6">
                    <v-alert type="success" text class="mb-4 text-body-2" style="border-radius: 8px">
                        <div class="d-flex align-center justify-space-between flex-wrap black--text">
                            <span>
                                Cálculo dinámico basado en los
                                <b>{{ selectedFundo.length }}</b> fundos seleccionados.
                            </span>
                            <span v-if="advanceProducer.TypeCurrency != 1" class="font-weight-bold">
                                Tipo de Cambio SBS: <span class="font-weight-black">{{ displayExchangeRate }}</span>
                            </span>
                        </div>
                    </v-alert>

                    <!-- Contenedor Tabla Estilo Excel -->
                    <div style="
              border-radius: 8px;
              overflow: hidden;
              border: 1px solid #cbd5e1;
              box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            ">
                        <!-- Fila de Encabezado Principal (PROYECCION) -->
                        <div class="text-center font-weight-bold py-2 text-caption uppercase" style="
                background-color: #e2e8f0;
                color: #334155;
                border-bottom: 1px solid #cbd5e1;
                letter-spacing: 1px;
              ">
                            PROYECCIÓN
                        </div>

                        <!-- Fila de Títulos de Columna -->
                        <v-row no-gutters class="text-center font-weight-bold py-2 text-caption grey lighten-4" style="
                border-bottom: 1px solid #cbd5e1;
                color: #475569;
                font-size: 10px !important;
              ">
                            <v-col style="border-right: 1px solid #e2e8f0"
                                class="pa-1 d-flex align-center justify-center">JABAS</v-col>
                            <v-col style="border-right: 1px solid #e2e8f0"
                                class="pa-1 d-flex align-center justify-center">PROMEDIO /
                                JABA</v-col>
                            <v-col style="border-right: 1px solid #e2e8f0"
                                class="pa-1 d-flex align-center justify-center">VOLUMEN
                                PROYECTADO</v-col>
                            <v-col style="border-right: 1px solid #e2e8f0"
                                class="pa-1 d-flex align-center justify-center">PRECIO / KG
                                SOLES</v-col>
                            <v-col style="border-right: 1px solid #e2e8f0"
                                class="pa-1 d-flex align-center justify-center">VALOR
                                TOTAL
                                DE
                                LA PRODUCCIÓN</v-col>
                            <v-col :style="advanceProducer.TypeCurrency != 1 ? 'border-right: 1px solid #e2e8f0' : ''"
                                class="pa-1 d-flex align-center justify-center">MONTO ANTICIPO SOLICITADO</v-col>
                            <v-col v-if="advanceProducer.TypeCurrency != 1"
                                class="pa-1 d-flex align-center justify-center">MONTO
                                ANTICIPO
                                SOLES</v-col>
                        </v-row>

                        <!-- Fila de Valores y Campos Editables -->
                        <v-row no-gutters class="text-center align-center"
                            style="background-color: #ffffff; font-size: 13px">
                            <!-- JABAS -->
                            <v-col style="border-right: 1px solid #e2e8f0; min-height: 56px"
                                class="pa-2 font-weight-medium grey lighten-5 d-flex align-center justify-center">
                                {{
                                    calcJabas.toLocaleString("es-PE", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                }}
                            </v-col>

                            <!-- PROMEDIO POR JABA -->
                            <v-col style="border-right: 1px solid #e2e8f0; min-height: 56px"
                                class="pa-2 d-flex align-center justify-center">
                                <v-text-field v-model.number="calcAvgPerJaba" type="number" dense hide-details outlined
                                    style="max-width: 90px" class="centered-input-field"></v-text-field>
                            </v-col>

                            <!-- VOLUMEN PROYECTADO -->
                            <v-col style="border-right: 1px solid #e2e8f0; min-height: 56px"
                                class="pa-2 font-weight-medium grey lighten-5 d-flex align-center justify-center">
                                {{
                                    calcVolumenProyectado.toLocaleString("es-PE", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                }}
                            </v-col>

                            <!-- PRECIO / KG -->
                            <v-col style="border-right: 1px solid #e2e8f0; min-height: 56px"
                                class="pa-2 d-flex align-center justify-center">
                                <v-text-field v-model.number="calcPrecioKg" type="number" step="0.01" dense hide-details
                                    outlined style="max-width: 90px" class="centered-input-field"></v-text-field>
                            </v-col>

                            <!-- VALOR TOTAL PRODUCCION -->
                            <v-col style="border-right: 1px solid #e2e8f0; min-height: 56px"
                                class="pa-2 font-weight-bold green--text text--darken-3 grey lighten-5 d-flex align-center justify-center">
                                {{ currencySymbol }}
                                {{
                                    calcValorTotalProduccion.toLocaleString("es-PE", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                }}
                            </v-col>

                            <!-- MONTO SOLICITADO ANTICIPO -->
                            <v-col
                                :style="advanceProducer.TypeCurrency != 1 ? 'border-right: 1px solid #e2e8f0; min-height: 56px' : 'min-height: 56px'"
                                class="pa-2 font-weight-bold blue--text text--darken-3 grey lighten-5 d-flex align-center justify-center">
                                {{ currencySymbol }}
                                {{
                                    calcMontoSolicitado.toLocaleString("es-PE", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                }}
                            </v-col>

                            <!-- MONTO ANTICIPO SOLES -->
                            <v-col v-if="advanceProducer.TypeCurrency != 1" style="min-height: 56px"
                                class="pa-2 font-weight-bold purple--text text--darken-3 grey lighten-5 d-flex align-center justify-center">
                                S/.
                                {{
                                    calcMontoSolicitadoSoles.toLocaleString("es-PE", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                }}
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Porcentaje de Anticipo Destacado -->
                    <v-row justify="center" class="mt-5">
                        <v-col cols="12" sm="6" md="5">
                            <v-card outlined class="pa-4 text-center" style="
                  border-radius: 12px;
                  border: 2px solid #cbd5e1;
                  background-color: #f8fafc;
                ">
                                <div class="text-caption font-weight-bold grey--text text--darken-2 mb-1">
                                    PORCENTAJE DE ANTICIPO
                                </div>
                                <div class="text-h3 font-weight-black primary--text">
                                    {{
                                        calcPorcentaje.toLocaleString("es-PE", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    }}
                                    %
                                </div>
                                <div class="text-caption mt-2 grey--text text--darken-1">
                                    (Total Anticipo x 100 / Valor Total Producción)
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="pa-4 grey lighten-4">
                    <v-spacer></v-spacer>
                    <v-btn large color="grey darken-3" dark class="px-6 text-none rounded-lg font-weight-bold"
                        @click="dialogProductionValue = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal: Ver Precio Mercado -->
        <v-dialog v-model="dialogMarketPrice" max-width="900px" persistent>
            <v-card style="border-radius: 12px; overflow: hidden">
                <v-card-title class="blue darken-3 white--text pa-4 d-flex align-center">
                    <v-icon color="white" class="mr-3">mdi-trending-up</v-icon>
                    <span class="text-h6 font-weight-bold">
                        Precios de Mercado {{ selectedFundoMarketPrice ? `- Lote: ${selectedFundoMarketPrice.FltName}` :
                            '' }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogMarketPrice = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6">
                    <div v-if="loadingMarketPrice" class="d-flex flex-column align-center justify-center py-8">
                        <v-progress-circular indeterminate color="primary" size="48" class="mb-4"></v-progress-circular>
                        <span class="text-body-2 grey--text text--darken-1">Cargando precios de mercado...</span>
                    </div>

                    <div v-else-if="!marketPriceList || marketPriceList.length === 0"
                        class="d-flex flex-column align-center justify-center py-8 text-center">
                        <v-icon color="grey lighten-1" size="48" class="mb-2">mdi-alert-circle-outline</v-icon>
                        <div class="grey--text text--darken-1 text-body-2">No se encontraron datos de precio de mercado
                            para
                            esta
                            campaña y productor.</div>
                    </div>

                    <div v-else>
                        <!-- Tabla de precios de mercado -->
                        <v-data-table mobile-breakpoint="0" dense :items="marketPriceList" :headers="headersMarketPrice"
                            class="elevation-1" :items-per-page="-1" hide-default-footer>
                            <template v-slot:item.CmaName="{ item }">
                                <span class="font-weight-medium">{{ item.CmaName || 'N/A' }}</span>
                            </template>
                            <template v-slot:item.TotalKilo="{ item }">
                                {{ formatNumber(item.TotalKilo) }} kg
                            </template>
                            <template v-slot:item.TotalAmount="{ item }">
                                <span class="font-weight-medium ">
                                    {{ formatNumber(item.TotalAmount) }}
                                </span>
                            </template>
                            <template v-slot:item.ProducerPurchasePrice="{ item }">
                                <span class="font-weight-medium blue--text text--darken-3">
                                    {{ formatNumber(item.ProducerPurchasePrice) }}
                                </span>
                            </template>
                            <template v-slot:item.MarketPurchasePrice="{ item }">
                                <span class="font-weight-medium red--text text--darken-3">
                                    {{ formatNumber(item.MarketPurchasePrice) }}
                                </span>
                            </template>
                        </v-data-table>
                    </div>
                </v-card-text>

                <v-card-actions class="pa-4 grey lighten-4">
                    <v-spacer></v-spacer>
                    <v-btn large color="grey darken-3" dark class="px-6 text-none rounded-lg font-weight-bold"
                        @click="dialogMarketPrice = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div v-if="dialogCircuit">
            <v-dialog v-model="dialogCircuit" width="80%" persistent>
                <s-toolbar color="primary" dark label="Circuitos Asociados a la Operación"
                    @close="dialogCircuit = false" close></s-toolbar>
                <v-card>
                    <v-container>
                        <v-row>
                            <v-col lg="7">
                                <v-data-table dense item-key="AccID" :items="circuits" :items-per-page="-1" :headers="[
                                    { value: 'AccID', text: 'ID' },
                                    { value: 'AccName', text: 'Circuito' },
                                    {
                                        value: 'actions',
                                        text: 'Acciones',
                                        sortable: false,
                                        align: 'center',
                                        width: 120,
                                    },
                                ]" @dblclick:row="saveWithCircuit" v-model="selectedCircuit"
                                    @click:row="rowClickCircuit">
                                    <template v-slot:item.actions="{ item }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon v-on="on" small elevation="0"
                                                    @click="saveWithCircuit(item)">
                                                    <v-icon color="green darken-4" x-small>mdi-check
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Asignar circuito</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-col>
                            <v-col lg="5">
                                <s-crud v-if="this.filterLevels.AccID != null" no-toolbar :config="configLevels"
                                    :filter="filterLevels" title="Niveles" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
        </div>

        <v-dialog v-model="dialogDissaproved" max-width="500px">
            <v-card>
                <v-card-title class="headline">Esta seguro de Rechazar?</v-card-title>
                <v-card-text>
                    <s-textarea autofocus label="Motivo de Rechazo" v-model="AtsObservation" />
                </v-card-text>
                <v-card-actions>
                    <v-btn color="red darken-1" text @click="closeDelete">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" dark @click="disapproved()">confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _AdvanceProducerService from "../../../services/Technicalassistance/AdvanceProducerService";
import _AdvanceProducerApprovalService from "../../../services/Technicalassistance/AdvanceProducerApprovalService";
import sArticleSearch from "@/components/Utils/Logistics/SArticleSearch";
import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
import SSelectCampaignArea from "../../../components/Utils/SSelectCampaignArea.vue";
import _CampaignAreaService from "../../../services/General/CampaignAreaService";
import _sApprovalLevel from "@/services/Security/ApprovalLevelsService";
import _sAdvanceProducerApproval from "@/services/Technicalassistance/AdvanceProducerApprovalService.js";
import _WeeklyProjectionService from "../../../services/Technicalassistance/WeeklyProjectionService";
import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer";
import SSelectSuperviceProducer from "@/components/HarvestSchedule/SSelectSuperviceProducer.vue";
import _OtherSupportService from "@/services/Security/OtherSupportService";

const localArticleSearch = {
    ...sArticleSearch,
    data() {
        const dataObj = sArticleSearch.data.call(this);
        if (dataObj && dataObj.configCrud && dataObj.configCrud.headers) {
            dataObj.configCrud.headers = dataObj.configCrud.headers.filter(
                (h) => h.value !== "LastPurPrice" && h.value !== "LastPurCurrency"
            );
        }
        return dataObj;
    }
};

export default {
    name: "AdvanceDetail",
    components: {
        sArticleSearch: localArticleSearch,
        SSearchLotByCodSenasa,
        SSelectDefinition,
        SSelectCampaignArea,
        SSelectProducer,
        SSelectSuperviceProducer,
    },
    props: {
        editData: {
            type: Object,
            default: () => ({}),
        },
        value: {
            type: Number,
            default: null,
        },
        isViewMode: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        options: [
            { value: 1, label: "INSUMOS", icon: "mdi-leaf" },
            { value: 2, label: "DINERO", icon: "mdi-cash-check" },
        ],
        objProducer: {},
        producerDebts: [],
        // ===== Items =====
        items: [],
        selected: [],
        article: null,
        item: {
            LsNumLine: 0,
            ApdID: 0,
            LsID: 0,
            ArtCode: "",
            Description: "",
            Quantity: 0,
            UnitPrice: 0,
            SecStatus: 1,
        },
        headersDetail: [
            { text: "Item", value: "LsNumLine", width: 80, align: "center" },
            {
                text: "Adelanto",
                value: "TypeAdvance",
                width: 80,
                align: "center",
                sortable: false,
            },
            { text: "Descripción", value: "Description", sortable: false },
            {
                text: "Cantidad",
                value: "Quantity",
                sortable: false,
                width: 70,
                align: "center",
            },
            {
                text: "P. Unitario",
                value: "UnitPrice",
                sortable: false,
                width: 80,
                align: "center",
            },
            {
                text: "Total",
                value: "totalRow",
                sortable: false,
                width: 90,
                align: "center",
            },
        ],
        // ===== Fundo =====
        fundos: [],
        selectedFundo: [],
        staticHeaders: [
            { text: "Id Lote", value: "FltID", sortable: false },
            { text: "Fundo", value: "FagName", sortable: false },
            { text: "Lote", value: "FltName", sortable: false, width: 100 },
            { text: "Dirección", value: "FagAddress", sortable: false },
            { text: "Tipo Cultivo", value: "TypeCropText", sortable: false },
            { text: "Variedad", value: "VrtIDText", sortable: false },
            { text: "Hectáreas", value: "FltHectares", sortable: false },
            { text: "Plantas", value: "FltPlants", sortable: false },
            { text: "Volumen", value: "FltVolume", sortable: false },
            { text: "Potencial Jabas", value: "FltJabasPotential", sortable: false },
            {
                text: "Est. Fenológico",
                value: "typeStatePhenologicalName",
                sortable: false,
            },
            { text: "% Avance", value: "StpPercentage", sortable: false },
            { text: "Inicio Cosecha", value: "DateBeginHarvest", sortable: false },
            { text: "Fin Cosecha", value: "DateEndHarvest", sortable: false },
            { text: "Proy. Jabas", value: "WptProjectedJabas", sortable: false },
            { text: "Ver PM", value: "actionsMarketPrice", sortable: false, align: "center" },
        ],
        // ===== Header =====
        selectedSubCampaign: [],
        campaignAreas: [],
        _loadingEditData: false,
        selectedCurrencyObject: { DedValue: 2, DedDescription: "DOLARES", DedHelper: "USD" },
        exchangeRate: null,
        advanceProducer: {
            AdpID: 0,
            CmaID: null,
            TypeAdvance: 1,
            AdpJustification: "",
            ApplicationDate: "",
            TypeCurrency: 2,
            AdpStatus: 4,
            SecStatus: 1,
            NtpSuperviceID: null,
            SuperviceName: "",
            TotalAmount: 0,
            ExchangeRate: 0,
            IncludesTax: false,
        },
        data: {},
        config: {
            model: {
                service: _AdvanceProducerService,
            },
        },
        dialogCircuit: false,
        circuits: [],
        selectedCircuit: [],
        filterLevels: {},
        configLevels: {
            model: {
                AccID: "int",
                AlvID: "ID",
                SecStatus: "boleam",
                PstID: "int",
                PstName: "string",
                OddAmount: "",
                OddUnitPrice: "",
                TaxCode: "",
            },
            service: _sApprovalLevel,
            headers: [
                { text: "Cargo", value: "PstName" },
                { text: "Nivel", value: "TypeLevelText" },
            ],
        },
        approvedOption: false,
        isUserCreated: true,
        viewMode: false,
        transactionApproved: null,
        full: [],
        AtsObservation: null,
        dialogDissaproved: false,
        TasWeeklyProjectionLoteCampaign: {
            typeStatePhenologicalName: "",
            StpPercentage: null,
            DateBeginharvest: "",
            DateEndharvest: "",
            WptProjectedJabas: null,
        },
        dialogProductionValue: false,
        calcAvgPerJaba: 19.5,
        calcPrecioKg: 0.6,
        dialogMarketPrice: false,
        loadingMarketPrice: false,
        marketPriceList: [],
        selectedFundoMarketPrice: null,
        headersMarketPrice: [
            { text: "Campaña", value: "CmaName", align: "start" },
            { text: "Total Kilos", value: "TotalKilo", align: "right" },
            { text: "Importe Total", value: "TotalAmount", align: "right" },
            { text: "P. Compra Productor", value: "ProducerPurchasePrice", align: "right" },
            { text: "P. Compra Mercado", value: "MarketPurchasePrice", align: "right" },
        ],
    }),
    computed: {
        isEditable() {
            return this.advanceProducer.AdpID > 0;
        },
        displayExchangeRate() {
            if (!this.exchangeRate) {
                return "0.00";
            }
            return Number(this.exchangeRate).toFixed(3);
        },
        user() {
            return this.$fun.getUserInfo();
        },
        totalSuppliesNet() {
            return this.items
                .filter((i) => i.SecStatus !== 0 && i.TypeAdvance == 1)
                .reduce((sum, item) => {
                    const q = parseFloat(item.Quantity) || 0;
                    const u = parseFloat(item.UnitPrice) || 0;
                    return sum + q * u;
                }, 0);
        },
        igvSuppliesAmount() {
            if (this.advanceProducer.TypeAdvance === 1 && this.advanceProducer.IncludesTax) {
                return this.totalSuppliesNet * 0.18;
            }
            return 0;
        },
        totalSuppliesWithTax() {
            return this.totalSuppliesNet + this.igvSuppliesAmount;
        },
        totalSupplies() {
            return this.totalSuppliesWithTax;
        },
        totalCash() {
            return this.items
                .filter((i) => i.SecStatus !== 0 && i.TypeAdvance == 2)
                .reduce((sum, item) => {
                    const amount = parseFloat(item.UnitPrice) || 0;
                    return sum + amount;
                }, 0);
        },
        totalAmount() {
            return this.totalSupplies + this.totalCash;
        },
        currencySymbol() {
            return this.advanceProducer.TypeCurrency == 1 ? "S/." : "$";
        },
        totalPotentialJabas() {
            if (!this.fundos || this.fundos.length === 0) return 0;
            return this.fundos.reduce(
                (sum, f) => sum + (parseFloat(f.FltJabasPotential) || 0),
                0,
            );
        },
        totalProjectedJabas() {
            if (!this.fundos || this.fundos.length === 0) return 0;
            return this.fundos.reduce(
                (sum, f) => sum + (parseFloat(f.WptProjectedJabas) || 0),
                0,
            );
        },
        computedHeaders() {
            const list = [...this.staticHeaders];
            (this.selectedSubCampaign || []).forEach((cmaId) => {
                const camp = this.campaignAreas.find((c) => c.CmaID === cmaId);
                if (camp) {
                    list.push({
                        text: `${camp.CmaName} (Kilos Recibidos)`,
                        value: `kilos_${cmaId}`,
                        sortable: false,
                        align: "right",
                    });
                }
            });
            return list;
        },
        calcJabas() {
            if (!this.selectedFundo || this.selectedFundo.length === 0) return 0;
            return this.selectedFundo.reduce(
                (sum, f) => sum + (parseFloat(f.FltJabasPotential) || 0),
                0,
            );
        },
        calcVolumenProyectado() {
            return this.calcJabas * (parseFloat(this.calcAvgPerJaba) || 0);
        },
        calcValorTotalProduccion() {
            return this.calcVolumenProyectado * (parseFloat(this.calcPrecioKg) || 0);
        },
        calcMontoSolicitado() {
            return this.totalAmount || 0;
        },
        calcMontoSolicitadoSoles() {
            const amount = this.totalAmount || 0;
            if (this.advanceProducer.TypeCurrency == 1) {
                return amount;
            }
            const rate = parseFloat(this.exchangeRate) || 0;
            return amount * rate;
        },
        calcPorcentaje() {
            if (!this.calcValorTotalProduccion) return 0;
            return (this.calcMontoSolicitado * 100) / this.calcValorTotalProduccion;
        },
    },
    watch: {
        "advanceProducer.ApplicationDate"(newVal) {
            if (newVal) {
                this.fetchExchangeRate();
            }
        },
        article(item) {
            this.item.ArtCode = item ? item.ArtCode : "";
            this.item.Description = item ? item.ArtName : "";
            this.item.LsID = 0;
            if (item) {
                if (item.ArticlePriceITM1 !== undefined && item.ArticlePriceITM1 !== null) {
                    this.item.UnitPrice = item.ArticlePriceITM1;
                } else if (item.LastPurPrice !== undefined && item.LastPurPrice !== null) {
                    this.item.UnitPrice = item.LastPurPrice;
                }
            }
            console.log("article", item);
        },
        "advanceProducer.TypeAdvance"(value, oldvalue) {
            this.item.LsID = 0;
            this.item.Description = "";
            if (this.items.length > 0) {
                this.items = this.items.filter((x) => x.TypeAdvance == value);
            }
            if (!this.isEditable) {
                if (value === 1) {
                    // Insumos -> Dólares por defecto (TypeCurrency = 2)
                    this.advanceProducer.TypeCurrency = 2;
                    this.selectedCurrencyObject = { DedValue: 2, DedDescription: "DOLARES", DedHelper: "USD" };
                } else if (value === 2) {
                    // Dinero -> Soles por defecto (TypeCurrency = 1)
                    this.advanceProducer.TypeCurrency = 1;
                    this.selectedCurrencyObject = { DedValue: 1, DedDescription: "SOLES", DedHelper: "SOL" };
                }
                this.fetchExchangeRate();
            }
        },
        async "advanceProducer.CmaID"(val) {
            this.fetchFundos();
            console.log("PARENT CAMPAIGN SELECCIONADO:", val);
            if (val) {
                try {
                    const response =
                        await _CampaignAreaService.CampaignAreaXTypeAreaTypeCultive(
                            3,
                            val,
                            this.$fun.getUserID(),
                        );
                    if (
                        response &&
                        response.status === 200 &&
                        Array.isArray(response.data)
                    ) {
                        this.campaignAreas = response.data;
                    } else {
                        this.campaignAreas = [];
                    }
                } catch (error) {
                    console.error("Error fetching sub-campaigns:", error);
                    this.campaignAreas = [];
                }

                if (!this._loadingEditData) {
                    this.selectedSubCampaign = [];
                }
            } else {
                this.campaignAreas = [];
                if (!this._loadingEditData) {
                    this.selectedSubCampaign = [];
                }
            }
        },

        objProducer(val) {
            console.log("PRODUCTOR SELECCIONADO:", JSON.parse(JSON.stringify(val)));
            if (val && typeof val === "object" && val.PrdID) {
                this.advanceProducer.PrdID = val.PrdID;
            } else if (val && (typeof val === "number" || typeof val === "string")) {
                this.advanceProducer.PrdID = Number(val);
            } else {
                this.advanceProducer.PrdID = null;
                this.advanceProducer.NtpSuperviceID = null;
                this.advanceProducer.SuperviceName = "";
            }
            this.fetchFundos();
            this.fetchProducerDebts();
        },
        async selectedSubCampaign(newVal, oldVal) {
            if (!newVal) return;
            const oldArr = oldVal || [];
            const added = newVal.filter((x) => !oldArr.includes(x));
            const removed = oldArr.filter((x) => !newVal.includes(x));

            // Clean up removed campaigns from fundos items
            removed.forEach((cmaId) => {
                this.fundos = this.fundos.map((item) => {
                    const newItem = { ...item };
                    delete newItem[`kilos_${cmaId}`];
                    return newItem;
                });
            });

            // Fetch data for newly checked campaigns
            if (added.length > 0) {
                if (!this.fundos || this.fundos.length === 0) return;
                const fltIdsStr = this.fundos.map((f) => f.FltID).join(",");
                const requestID = this.$fun.getUserID();

                for (const cmaId of added) {
                    try {
                        const response =
                            await _AdvanceProducerService.SummaryFreshReceiptJabas(
                                cmaId,
                                fltIdsStr,
                                requestID,
                            );
                        if (
                            response &&
                            response.status === 200 &&
                            Array.isArray(response.data)
                        ) {
                            this.fundos = this.fundos.map((item) => {
                                const match = response.data.find((r) => r.FltID === item.FltID);
                                const qty = match ? match.KilosQuantity : 0;
                                return {
                                    ...item,
                                    [`kilos_${cmaId}`]: this.formatJabas(qty),
                                };
                            });
                        }
                    } catch (e) {
                        console.error(
                            `Error loading Kilos quantity for campaign ${cmaId}:`,
                            e,
                        );
                    }
                }
            }
        },
        editData: {
            immediate: true,
            handler(item) {
                if (Object.keys(item).length > 0) {
                    console.log("editData en watcher", item);
                    this.advanceProducer = { ...item };
                    this.advanceProducer.AdpID = item.AdpID;
                    this.advanceProducer.CmaID = item.CmaID;
                    this.advanceProducer.TypeAdvance = item.TypeAdvance;
                    this.advanceProducer.AdpStatus = item.AdpStatus;
                    this.advanceProducer.ApplicationDate = item.ApplicationDate;
                    this.advanceProducer.SecStatus = item.SecStatus;
                    this.advanceProducer.AdpJustification = item.AdpJustification;
                    this.advanceProducer.Observation = item.Observation;
                    this.advanceProducer.TypeCurrency = item.TypeCurrency || 2;
                    this.advanceProducer.IncludesTax = item.IncludesTax !== undefined ? item.IncludesTax : false;
                    this.selectedCurrencyObject = {
                        DedValue: item.TypeCurrency || 2,
                        DedDescription: item.TypeCurrencyName || (item.TypeCurrency === 1 ? "SOLES" : "DOLARES"),
                        DedHelper: item.TypeCurrencyName || (item.TypeCurrency === 1 ? "SOL" : "USD")
                    };
                    this.exchangeRate = item.ExchangeRate || null;
                    if (!this.exchangeRate) {
                        this.fetchExchangeRate();
                    }
                    this.advanceProducer.PrdCardName = item.PrdCardName;
                    this.advanceProducer.ProducerName =
                        item.ProducerName || item.PrdCardName || item.PrdText || "";
                    this.advanceProducer.TotalAmount = item.TotalAmount || 0;

                    this.objProducer = {
                        PrdID: item.PrdID,
                        PrdCardName: item.PrdCardName || item.PrdText || "",
                    };

                    // Cargar fundos desde AdvanceProducerFarmLot
                    if (
                        item.AdvanceProducerFarmLot &&
                        item.AdvanceProducerFarmLot.length > 0
                    ) {
                        const savedOnly = item.AdvanceProducerFarmLot.filter(
                            (f) => f.ApfID && f.ApfID > 0,
                        );
                        this._originalSavedFundos = savedOnly;

                        if (this.isViewMode) {
                            this.fundos = savedOnly;
                            this.selectedFundo = [...this.fundos];
                        } else {
                            this._savedFundos = savedOnly;
                            // fetchFundos will auto-match these and place them in selectedFundo
                        }
                    }

                    // Cargar items
                    if (
                        item.AdvanceProducerDetail &&
                        item.AdvanceProducerDetail.length > 0
                    ) {
                        this.items = item.AdvanceProducerDetail.map((d) => ({
                            LsNumLine: d.ApdID,
                            ApdID: d.ApdID,
                            LsID: d.LsID,
                            ArtCode: d.ArtCode,
                            Description: d.Description,
                            DedDescription: d.DedDescription,
                            Quantity: d.Quantity,
                            UnitPrice: d.UnitPrice,
                            Total: d.Total,
                            TypeAdvance: d.TypeAdvance || item.TypeAdvance || 1,
                            SecStatus: d.SecStatus,
                        }));
                    }

                    if (this.isViewMode) {
                        this.viewMode = true;
                        this.isUserCreated = false;
                    } else {
                        this.viewMode = false;
                        this.isUserCreated = true;
                    }
                }
            },
        },
    },
    methods: {
        handleProducerChange(producer) {
            if (producer) {
                this.objProducer = producer;
                this.advanceProducer.PrdCardName = producer.PrdCardName;
            } else {
                this.objProducer = {};
                this.advanceProducer.PrdCardName = "";
            }
        },
        handleCurrencyChange(currencyObj) {
            console.log("MONEDA SELECCIONADA:", currencyObj);
            if (currencyObj && typeof currencyObj === "object") {
                this.advanceProducer.TypeCurrency = currencyObj.DedValue;
                this.selectedCurrencyObject = currencyObj;
                this.fetchExchangeRate();
            } else {
                this.advanceProducer.TypeCurrency = currencyObj;
                this.selectedCurrencyObject = null;
                this.exchangeRate = null;
            }
        },
        async fetchExchangeRate() {
            if (
                this.advanceProducer.ApplicationDate &&
                this.selectedCurrencyObject &&
                this.selectedCurrencyObject.DedHelper
            ) {
                try {
                    const dateStr = this.advanceProducer.ApplicationDate;
                    const currencyName = this.selectedCurrencyObject.DedHelper;
                    const requestID = this.$fun.getUserID();

                    console.log("Calling exchangeratesap with:", dateStr, currencyName, requestID);

                    const response = await _OtherSupportService.exchangeratesap(
                        dateStr,
                        currencyName,
                        requestID
                    );

                    if (response && response.status === 200 && response.data) {
                        this.exchangeRate = response.data.Rate || null;
                        console.log("Exchange rate loaded:", this.exchangeRate);
                    } else {
                        this.exchangeRate = null;
                    }
                } catch (error) {
                    console.error("Error fetching exchange rate:", error);
                    this.exchangeRate = null;
                }
            } else {
                this.exchangeRate = null;
            }
        },
        async fetchFundos() {
            if (this.advanceProducer.CmaID && this.advanceProducer.PrdID) {
                try {
                    const response = await _AdvanceProducerService.FarmbyProducer(
                        this.advanceProducer.PrdID,
                        this.advanceProducer.CmaID,
                        this.$fun.getUserID(),
                    );
                    if (response && response.data) {
                        this.fundos = response.data;
                        if (this._savedFundos && this._savedFundos.length > 0) {
                            const savedIds = this._savedFundos.map((f) => f.FltID);
                            this.selectedFundo = this.fundos.filter((f) =>
                                savedIds.includes(f.FltID),
                            );
                            this._savedFundos = [];
                        }
                    }
                } catch (error) {
                    console.error("Error fetching fundos:", error);
                    this.fundos = [];
                }
            } else {
                this.fundos = [];
            }
        },

        // ===== Métodos de Items =====
        searchSenasa() {
            // Mantenido por compatibilidad, ya no se usa en el header
        },
        clearFormDetail() {
            this.item = {
                LsNumLine: 0,
                ApdID: 0,
                LsID: 0,
                ArtCode: "",
                Description: "",
                Quantity: 0,
                UnitPrice: 0,
                SecStatus: 1,
            };
            this.article = null;
            this.selected = [];
        },
        clearForm() {
            this.advanceProducer = {
                AdpID: 0,
                CmaID: null,
                TypeAdvance: 1,
                AdpJustification: "",
                ApplicationDate: "",
                TypeCurrency: 2,
                AdpStatus: null,
                SecStatus: 1,
                NtpSuperviceID: null,
                SuperviceName: "",
                TotalAmount: 0,
                ExchangeRate: 0,
                IncludesTax: false,
            };
            this.items = [];
            this.fundos = [];
            this.objProducer = {};
            this.selectedFundo = [];
            this.producerDebts = [];
            this.selectedSubCampaign = [];
            this.campaignAreas = [];
            this.selectedCurrencyObject = null;
            this.exchangeRate = null;
        },
        edit() {
            if (this.selected.length > 0) {
                this.item = { ...this.selected[0] };
                if (this.item.TypeAdvance == 2) {
                    this.item.Quantity = this.item.UnitPrice;
                    this.item.UnitPrice = 0;
                }
                this.article = {
                    ArtCode: this.selected[0].ArtCode,
                    ArtName: this.selected[0].Description,
                };
            }
        },
        add() {
            const TypeAdvance = this.advanceProducer.TypeAdvance.toString().trim();

            if (
                TypeAdvance == 1 &&
                (this.item.ArtCode == undefined ||
                    this.item.ArtCode == null ||
                    this.item.ArtCode.toString().trim() == "")
            ) {
                this.$fun.alert("Seleccionar insumo", "warning");
                return;
            }
            if (TypeAdvance == 2 && this.item.Description.toString().trim() == "") {
                this.$fun.alert("Agregar Descripción", "warning");
                return;
            }
            // Verificar duplicado (solo entre los activos)
            if (
                this.item.LsNumLine == 0 &&
                this.items.find(
                    (x) =>
                        x.Description.toString().toLowerCase() ==
                        this.item.Description.toString().toLowerCase() &&
                        x.SecStatus !== 0,
                )
            ) {
                this.$fun.alert("Descripción ya fue agregada", "warning");
                return;
            }
            this.item.Quantity = parseFloat(this.item.Quantity);
            if (
                typeof this.item.Quantity !== "number" ||
                isNaN(this.item.Quantity) ||
                this.item.Quantity <= 0
            ) {
                console.log("Cantidad inválida:", this.item.Quantity);

                let msg = TypeAdvance == 1 ? "Cantidad" : "Monto";
                this.$fun.alert(msg + " debe ser mayor a cero", "warning");
                this.$refs.LsQuantity.focus();
                return;
            }

            this.item.UnitPrice = parseFloat(this.item.UnitPrice || 0);
            if (
                TypeAdvance == 1 &&
                (typeof this.item.UnitPrice !== "number" ||
                    isNaN(this.item.UnitPrice) ||
                    this.item.UnitPrice <= 0)
            ) {
                this.$fun.alert("El Precio Unitario debe ser mayor a cero", "warning");
                this.$refs.LsUnitPrice.focus();
                return;
            }

            const activeLines = this.items.filter((i) => i.SecStatus !== 0);
            const maxLine =
                activeLines.length > 0
                    ? Math.max(...activeLines.map((i) => i.LsNumLine))
                    : 0;
            const UsrCreateID = this.$fun.getUserID();
            let mappedQuantity = this.item.Quantity;
            let mappedUnitPrice = this.item.UnitPrice;
            if (TypeAdvance == 2) {
                mappedUnitPrice = this.item.Quantity;
                mappedQuantity = 1;
            }

            let TasAdvanceProducerDetail = {
                ...this.item,
                Quantity: mappedQuantity,
                UnitPrice: mappedUnitPrice,
                Total: mappedQuantity * mappedUnitPrice,
                UsrCreateID,
                AdpID: this.advanceProducer.AdpID > 0 ? this.advanceProducer.AdpID : 0,
                TypeAdvance: this.advanceProducer.TypeAdvance,
                LsNumLine: this.item.LsNumLine > 0 ? this.item.LsNumLine : maxLine + 1,
                SecStatus: 1,
                ArtCode: this.item.ArtCode ? this.item.ArtCode : "",
                LsID: null, // Asegurar LsID en 0
            };

            if (this.item.LsNumLine > 0) {
                // Modo edición: actualizar en el array local
                this.items = this.items.map((x) =>
                    x.LsNumLine == this.item.LsNumLine
                        ? { ...TasAdvanceProducerDetail }
                        : x,
                );
            } else {
                // Modo agregar: insertar en el array local
                this.items.push(TasAdvanceProducerDetail);
            }
            this.clearFormDetail();
        },
        removeItem() {
            if (this.selected.length > 0) {
                let itemRemove = this.selected[0];
                this.$fun
                    .alert("Seguro de Eliminar Registro?", "question")
                    .then((result) => {
                        if (result.value) {
                            if (itemRemove.ApdID > 0) {
                                // Si está registrado en BD (ApdID > 0), cambiar SecStatus a 0
                                this.items = this.items.map((x) =>
                                    x.LsNumLine == itemRemove.LsNumLine
                                        ? { ...x, SecStatus: 0 }
                                        : x,
                                );
                            } else {
                                // Si es nuevo (ApdID == 0), eliminarlo por completo del array
                                this.items = this.items.filter(
                                    (x) => x.LsNumLine != itemRemove.LsNumLine,
                                );
                            }
                            this.selected = [];
                            this.clearFormDetail();
                        }
                    });
            }
        },
        rowClick: function (item) {
            console.log("rowclick item:", item);

            this.selected = [item];
        },
        async save() {
            try {
                console.log("save advanceProducer", this.advanceProducer);

                if (
                    this.advanceProducer.ApplicationDate == undefined ||
                    this.advanceProducer.ApplicationDate.toString().trim() == ""
                ) {
                    this.$fun.alert("Seleccionar Fecha", "warning");
                    return;
                }
                if (this.selectedFundo.length == 0) {
                    this.$fun.alert("Seleccionar al menos un Fundo", "warning");
                    return;
                }
                if (
                    this.advanceProducer.CmaID == undefined ||
                    this.advanceProducer.CmaID <= 0
                ) {
                    this.$fun.alert("Seleccionar campaña", "warning");
                    return;
                }
                if (
                    this.advanceProducer.AdpJustification == undefined ||
                    this.advanceProducer.AdpJustification.toString().trim() == ""
                ) {
                    this.$fun.alert("Ingresar justificación", "warning");
                    this.$refs.APJustification.focus();
                    return;
                }
                if (this.items.length == 0) {
                    this.$fun.alert("Agregar detalle de item", "warning");
                    return;
                }

                const requestID = this.$fun.getUserID();
                const advanceProducer = {
                    ...this.advanceProducer,
                    IncludesTax: this.advanceProducer.TypeAdvance === 1 ? (this.advanceProducer.IncludesTax ? 1 : 0) : 0,
                    ExchangeRate: parseFloat(this.exchangeRate) || 0,
                    TotalAmount: this.totalAmount,
                    UsrCreateID: requestID,
                    AdvanceProducerDetail: this.items,
                    AdvanceProducerFarmLot: [
                        ...this.selectedFundo.map((f) => {
                            const saved = (this._originalSavedFundos || []).find(
                                (s) => s.FltID === f.FltID,
                            );
                            return {
                                ApfID: saved ? saved.ApfID : 0,
                                AdpID:
                                    this.advanceProducer.AdpID > 0 ? this.advanceProducer.AdpID : 0,
                                FltID: f.FltID,
                                SecStatus: 1,
                                UsrCreateID: requestID,
                                UsrUpdateID: requestID,
                            };
                        }),
                        ...(this._originalSavedFundos || [])
                            .filter((s) => !this.selectedFundo.some((f) => f.FltID === s.FltID))
                            .map((s) => ({
                                ApfID: s.ApfID,
                                AdpID:
                                    this.advanceProducer.AdpID > 0 ? this.advanceProducer.AdpID : 0,
                                FltID: s.FltID,
                                SecStatus: 0,
                                UsrCreateID: requestID,
                                UsrUpdateID: requestID,
                            })),
                    ],
                };
                this.advanceProducer = { ...advanceProducer };

                const obj = {
                    UsrCreateID: this.$fun.getUserID(),
                    TypeApproval: 3,
                    TransactionID: 1,
                    DocEntry:
                        this.advanceProducer.AdpID > 0 ? this.advanceProducer.AdpID : 0,
                };

                const circuitsResponse = await _AdvanceProducerService.getCircuits(
                    obj,
                    requestID,
                );

                if (circuitsResponse.status == 200 && circuitsResponse.data.length > 0) {
                    this.circuits = circuitsResponse.data;
                    this.dialogCircuit = true;
                } else {
                    this.saveWithCircuit();
                }
            } catch (error) {
                console.error("Error al procesar el guardado:", error);
                const errorMsg =
                    error.response?.data?.Message ||
                    error.response?.data?.message ||
                    error.response?.data ||
                    error.message ||
                    "Ocurrió un error inesperado al procesar el guardado.";
                this.$fun.alert(errorMsg, "error");
            }
        },
        formatNumber(value, maxDecimals = 6) {
            if (value === undefined || value === null || isNaN(Number(value)))
                return "0.00";
            const num = Number(value);
            // Si es entero o tiene max 2 decimales, mostrar mínimo 2; si tiene más precisión, mostrar hasta maxDecimals sin truncar innecesariamente
            const hasMoreDecimals = (num.toString().split(".")[1] || "").length > 2;
            const maxFrac = hasMoreDecimals ? Math.min((num.toString().split(".")[1] || "").length, maxDecimals) : 2;
            return num.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: maxFrac,
            });
        },
        formatCurrency2Decimals(value) {
            if (value === undefined || value === null || isNaN(Number(value)))
                return "0.00";
            return Number(value).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        formatJabas(value) {
            if (value === undefined || value === null || isNaN(Number(value)))
                return "0";
            return Math.round(Number(value)).toLocaleString("en-US");
        },
        async fetchProducerDebts() {
            if (this.advanceProducer.PrdID) {
                try {
                    const response =
                        await _AdvanceProducerService.AdvanceProducerProducerDebt(
                            this.advanceProducer.PrdID,
                            this.$fun.getUserID(),
                        );
                    if (response && response.status === 200) {
                        this.producerDebts = Array.isArray(response.data)
                            ? response.data
                            : response.data.data || [];
                        console.log(JSON.parse(JSON.stringify(this.producerDebts)));
                    } else {
                        this.producerDebts = [];
                    }
                } catch (error) {
                    console.error("Error fetching producer debts:", error);
                    this.producerDebts = [];
                }
            } else {
                this.producerDebts = [];
            }
        },

        isItemEditable() {
            return this.selected.length > 0 && this.viewMode == false;
        },
        rowClickCircuit: function (item, row) {
            this.selectedCircuit = [item];
            this.filterLevels = { AccID: item.AccID };
        },
        saveWithCircuit() {
            console.log("advanceProducer", this.advanceProducer);

            const isUpdate = this.advanceProducer.AdpID > 0;
            const message = isUpdate
                ? "Seguro de Actualizar Registro?"
                : "Seguro de Guardar Registro?";
            const successMessage = isUpdate
                ? "Actualizado correctamente."
                : "Registrado correctamente.";

            if (isUpdate) {
                this.advanceProducer.AdpStatus = 4;
            }

            this.$fun.alert(message, "question").then((result) => {
                if (result.value) {
                    this.advanceProducer.AccID = this.selectedCircuit[0]?.AccID || null;
                    this.advanceProducer.UsrCreateID = this.$fun.getUserID();
                    this.advanceProducer.UsrUpdateID = this.$fun.getUserID();
                    this.advanceProducer.IncludesTax = this.advanceProducer.TypeAdvance === 1 
                        ? (this.advanceProducer.IncludesTax ? 1 : 0) 
                        : 0;
                    _AdvanceProducerService
                        .save(this.advanceProducer, this.$fun.getUserID())
                        .then((res) => {
                            if (res.status == 200) {
                                this.$emit("close");
                                this.$fun.alert(successMessage, "success");
                                this.clearForm();
                                this.clearFormDetail();
                            }
                        })
                        .catch((error) => {
                            console.error("Error al guardar:", error);
                            const errorMsg =
                                error.response?.data?.Message ||
                                error.response?.data?.message ||
                                error.response?.data ||
                                error.message ||
                                "Error al guardar el registro.";
                            this.$fun.alert(errorMsg, "error");
                        });
                }
            });
        },
        approved() {
            this.full = [];
            this.transactionApproved.AtsStatus = 2;
            this.transactionApproved.UsrCreateID = this.$fun.getUserID();
            this.full.push(this.transactionApproved);

            this.saveApproval(this.full, 1);
        },
        disapproved() {
            this.full = [];
            this.transactionApproved.AtsStatus = 3;
            this.transactionApproved.UsrCreateID = this.$fun.getUserID();
            this.transactionApproved.AtsObservation = this.AtsObservation;
            this.full.push(this.transactionApproved);

            this.saveApproval(this.full, 2);
        },
        closeDelete() {
            this.dialogDissaproved = false;
            this.AtsObservation = "";
        },
        async openMarketPriceDialog(fundo = null) {
            if (!this.advanceProducer.CmaID || !this.advanceProducer.PrdID) {
                this.$fun.alert("Seleccione Campaña y Productor primero", "warning");
                return;
            }
            this.dialogMarketPrice = true;
            this.loadingMarketPrice = true;
            this.marketPriceList = [];
            this.selectedFundoMarketPrice = fundo;
            const fltID = fundo ? fundo.FltID : 0;
            try {
                const response = await _AdvanceProducerService.PurchasePricebyProducer(
                    this.advanceProducer.CmaID,
                    this.advanceProducer.PrdID,
                    fltID,
                    this.$fun.getUserID()
                );
                if (response && response.status === 200) {
                    this.marketPriceList = Array.isArray(response.data) ? response.data : [response.data].filter(Boolean);
                } else {
                    this.marketPriceList = [];
                }
            } catch (error) {
                console.error("Error fetching market price:", error);
                this.$fun.alert("Error al cargar los precios de mercado.", "error");
                this.dialogMarketPrice = false;
            } finally {
                this.loadingMarketPrice = false;
            }
        },
        saveApproval(item, transaction) {
            console.log("item", item);
            this.$fun.alert("Confirmar Operación?", "question").then((r) => {
                if (r.value) {
                    var message;
                    if (transaction == 1) {
                        message = "Guardado Correctamente";
                    } else {
                        message = "Actualizado Correctamente";
                    }

                    _sAdvanceProducerApproval
                        .save(item, this.$fun.getUserID())
                        .then((r) => {
                            this.$fun.alert(message, "success");
                            this.$emit("close");
                        });
                }
            });
        },
    },
    created() {
        console.log("this.value", this.value);
        if (this.value != null && this.value > 0) {
            _AdvanceProducerApprovalService
                .byID({ AdpID: this.value }, this.$fun.getUserID())
                .then((r) => {
                    let data = r.data;
                    if (Object.keys(data).length > 0) {
                        this.advanceProducer = { ...data };
                        this.advanceProducer.AdpID = data.AdpID;
                        this.advanceProducer.CmaID = data.CmaID;
                        this.advanceProducer.AdpStatus = data.AdpStatus;
                        this.advanceProducer.ApplicationDate = data.ApplicationDate;
                        this.advanceProducer.TypeAdvance = data.TypeAdvance || 1;
                        this.advanceProducer.SecStatus = data.SecStatus;
                        this.advanceProducer.TotalAmount = data.TotalAmount || 0;
                        this.advanceProducer.ProducerName =
                            data.ProducerName || data.PrdCardName || data.PrdText || "";

                        this.objProducer = {
                            PrdID: data.PrdID,
                            PrdCardName: data.PrdCardName || data.PrdText || "",
                        };

                        // Cargar fundos

                        const reqID = this.$fun.getUserID();
                        const paramPg = {
                            filter: {},
                            draw: 1,
                            start: 0,
                            length: -1,
                            order: [{ dir: "asc", column: "" }],
                            searchText: "",
                        };
                        _AdvanceProducerService
                            .getAdvanceProducerFarmLots(paramPg, this.value, reqID)
                            .then((res) => {
                                if (res.status == 200 && res.data && res.data.data) {
                                    this.fundos = res.data.data.map((f, idx) => ({
                                        ...f,
                                        ApfNumLine: f.ApfID || idx + 1,
                                        ApfID: f.ApfID || 0,
                                        AdpID: f.AdpID || 0,
                                        PrdID: f.PrdID,
                                        FltID: f.FltID,
                                        PrdCardCodeRc: f.PrdCardCodeRc,
                                        FagName: f.FagName || "",
                                        FltName: f.FltName || "",
                                        PrdText: f.PrdCardName || f.PrdText || "",
                                        ResponsibleName:
                                            f.PrdCardCodeRcFullName || f.ResponsibleName || "",
                                        SecStatus: f.SecStatus !== undefined ? f.SecStatus : 1,
                                    }));
                                    this.selectedFundo = [...this.fundos];
                                }
                            });

                        // Cargar items
                        if (
                            data.AdvanceProducerDetail &&
                            data.AdvanceProducerDetail.length > 0
                        ) {
                            this.items = data.AdvanceProducerDetail.map((item) => ({
                                ...item,
                                LsNumLine: item.ApdID,
                                ApdID: item.ApdID,
                                LsID: item.LsID,
                                ArtCode: item.ArtCode,
                                Description: item.Description,
                                DedDescription: item.DedDescription,
                                Quantity: item.Quantity,
                                UnitPrice: item.UnitPrice || 0,
                                Total: item.Total,
                                TypeAdvance: item.TypeAdvance || data.TypeAdvance,
                                SecStatus: item.SecStatus,
                            }));
                        }

                        if (this.advanceProducer.Transaction != null)
                            if (this.advanceProducer.Transaction.UsersApproved.length > 0)
                                if (
                                    this.advanceProducer.Transaction.UsersApproved.find(
                                        (x) => x.UsrID == this.$fun.getUserID(),
                                    )
                                )
                                    if (this.advanceProducer.AdpStatus == 4)
                                        this.approvedOption = true;

                        if (
                            this.advanceProducer.UsrCreateID == this.$fun.getUserID() &&
                            this.advanceProducer.AdpStatus == 3
                        ) {
                            this.viewMode = false;
                            this.isUserCreated = true;
                        } else {
                            this.viewMode = true;
                            this.isUserCreated = false;
                        }
                    }

                    this.transactionApproved = r.data.Transaction;
                });
        }
    },
};
</script>

<style scoped>
/* Contenedor de botones */
.control {
    position: relative;
    display: flex;
    width: 100%;
    border-radius: 0.925rem;
    justify-content: space-between;
    z-index: 1;
    background: transparent !important;
    box-shadow: none !important;
}

/* Cada botón */
.seg-btn {
    flex: 1 1 0;
    min-width: 0;
    /* border-radius: 0.625rem; */
    transition: color 0.2s ease;
    justify-content: center;
    padding: 0.365rem !important;
}

/* Usamos atributo aria-pressed ya presente para detectar el activo */
.seg-btn[aria-pressed="true"] {
    background-color: var(--v-light-blue, #1976d2);
    color: white !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.seg-btn[aria-pressed="true"] .v-icon {
    color: white !important;
}

.centered-input-field>>>input {
    text-align: center !important;
}
</style>
